import React from 'react';

// styling
import './assessments.css';

// emoji
import './emoji.css';
import { Animated } from 'react-animated-css';

const UpgradedAssessmentOption = props => {
    const mod = 20; // used to compute transparency from slide value
    // function calculateBackground(answerType, answer) {
    //   if(props.answerType === props.answer){
    //     // return `rgb(255, 0, 51, ${1- (props.sliderValue % 20)/mod} )`
    //     return "#999"
    //   }else if((answerType === answer -1)){
    //     // return `rgba(255, 0, 51, ${(props.sliderValue % 20) /mod})`}
    //     return "#1a1a1a"}
    //     else{
    //       return 'rgb(26, 26, 26)'
    //     }
    // }

    function calculateBackground2(sliderValue, answerType, answer, displayOrder) {
      if(sliderValue >= 0 && sliderValue <= 19) {
        if(displayOrder === 1){
          return `rgb(172, 255, 36, ${(sliderValue % mod)/20} )`
        }
        else{
          return '#1a1a1a';
        }
      }
      else if(sliderValue >= 20 && sliderValue <= 39) {
        if(displayOrder === 1){
          return `rgb(172, 255, 36, ${1- (sliderValue % mod)/20} )`
        }else if(displayOrder === 2) {
          return `rgb(172, 255, 36, ${(sliderValue % mod)/20} )`
        }else{
          return '#1a1a1a';
        }
      }
      else if(sliderValue >= 40 && sliderValue <= 59) {
        if(displayOrder === 2){
          return `rgb(172, 255, 36, ${1- (sliderValue % mod)/20} )`
        }else if(displayOrder === 3) {
          return `rgb(172, 255, 36, ${(sliderValue % mod)/20} )`
        }else{
          return '#1a1a1a';
        }
      }
      else if(sliderValue >= 60 && sliderValue <= 79) {
        if(displayOrder === 3){
          return `rgb(172, 255, 36, ${1- (sliderValue % mod)/20} )`
        }else if(displayOrder === 4) {
          return `rgb(172, 255, 36, ${(sliderValue % mod)/20} )`
        }else{
          return '#1a1a1a';
        }
      }else if(sliderValue >= 80 && sliderValue <=99){
        if(displayOrder === 4){
          return `rgb(172, 255, 36, ${1- (sliderValue % mod)/20} )`
        }else if(displayOrder === 5) {
          return `rgb(172, 255, 36, ${(sliderValue % mod)/20} )`
        }else{
          return '#1a1a1a';
        }
      }
      else if(sliderValue === 100){
        if(displayOrder === 4){
          return `rgb(172, 255, 36, 0)`
        }else if(displayOrder === 5) {
          return `rgb(172, 255, 36, 1 )`
        }else{
          return '#1a1a1a';
        }
      }
      else {return "#1a1a1a"}
    }
   
    return (
      <Animated animationIn="zoomIn" animationOut="fadeOut" isVisible={true} animationInDuration={800} animationInDelay={650}>
      <li className="upgraded-answer-option" style={{backgroundColor: "#1a1a1a"}}>
        <div className="answer-wrap" style={{backgroundColor: calculateBackground2(props.sliderValue, props.answerType, props.answer, props.displayOrder)}}>
           <i className={"em " + props.icon} style={{margin: '0.5em'}} />
        <label>{props.answerContent}</label>
        </div>       
      </li>
      </Animated>
    );
};

export default UpgradedAssessmentOption;


// WEBPACK FOOTER //
// ./src/common/upgradedAssessmentOption.Component.tsx